import { render, staticRenderFns } from "./TopStartups.vue?vue&type=template&id=3b78297e&scoped=true&"
import script from "./TopStartups.vue?vue&type=script&lang=js&"
export * from "./TopStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78297e",
  null
  
)

export default component.exports